export default __webpack_public_path__ + "static/media/deposit.c21b2c47.webp";